export default __webpack_public_path__ + "static/media/Bjorn_Halo.5c5735da.png";